import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Link, useHistory } from 'react-router-dom'
import { FiAlertTriangle, FiArrowLeft, FiEdit, FiTrash } from 'react-icons/fi'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { format } from 'date-fns'

import Card from '../../../../components/Card'
import Spinner from '../../../../components/Spinner'
import { api, authHeaders } from '../../../../services/api'
import Modal from '../../../../components/Modal'
import { Button } from '../../../../components/Form'
import FormCadastro from '../FormCadastro'

export default function () {
	const { id } = useParams()

	const history = useHistory()

	const [isConfirmationDeleteOpen, setIsConfirmationDeleteOpen] = useState(false)
	const [lembreteEmEdicao, setLembreteEmEdicao] = useState(null)

	const { data: lembrete, isFetching, refetch: refetchLembrete } = useQuery({
		queryKey: ['obter-lembretes-por-id'],
		queryFn: async () => {
			try {
				const response = await api.get(`lembrete/${id}`, authHeaders())

				return response
			} catch(e) {
				
			}
		}
	})

	async function handleConfirmarExclusao() {
		try {
			await api.delete(`lembrete/${id}`, authHeaders())

			toast.success('Lembrete removido com sucesso.')

			history.push('/agenda')
		} catch(e) {
			toast.error(e.msg)
		}
	}

	return (
		<>
			<div className="md:w-[80vw] md:mx-auto md:my-12">
				<Card className="flex flex-col gap-4 text-slate-800">
					{isFetching ? (
						<Spinner />
					) : !lembrete ? (
						<div className="flex flex-col gap-3 text-slate-400 items-center my-24">
							<FiAlertTriangle size={28} />
							<p>Lembrete não identificado.</p>

							<Link to="/agenda" className="mt-8">
								Voltar para agenda
							</Link>
						</div>
					) :
					(
						<>
							<div className="flex gap-6 justify-between">
								<h1 className="text-slate-800">{lembrete.titulo}</h1>

								<div className="flex gap-4 items-center">
									<div 
										className="p-2 rounded-md text-sky-700 cursor-pointer bg-sky-100 hover:opacity-70"
										onClick={() => {
											setLembreteEmEdicao(lembrete)
										}}
									>
										<FiEdit size={18} />
									</div>

									<div 
										className="p-2 rounded-md text-red-700 cursor-pointer bg-red-100 hover:opacity-70"
										onClick={() => {
											setIsConfirmationDeleteOpen(true)
										}}
									>
										<FiTrash size={18} />
									</div>
								</div>
							</div>

							<p className="font-semibold">{lembrete.tipo.descricao}</p>

							<div className="flex gap-4">
								<div className="flex flex-col bg-slate-200 items-center p-3 rounded-md">
									<span className="font-semibold">Início</span>
									<span>{format(new Date(lembrete.inicio), 'dd/MM/yyyy')}</span>
									<span>{format(new Date(lembrete.inicio), 'HH:mm\'h\'')}</span>
								</div>

								<div className="h-[0.5px] w-24 bg-slate-300 mt-10"></div>

								<div className="flex flex-col bg-slate-200 items-center p-3 rounded-md">
									<span className="font-semibold">Fim</span>
									<span>{format(new Date(lembrete.fim), 'dd/MM/yyyy')}</span>
									<span>{format(new Date(lembrete.fim), 'HH:mm\'h\'')}</span>
								</div>
							</div>

							<div>{lembrete.descricao}</div>

							<Link to="/agenda" className="mt-8 flex items-center gap-1">
								<FiArrowLeft size={16} />
								Voltar para agenda
							</Link>
						</>
					)}		
				</Card>
			</div>

			<Modal
				isOpen={isConfirmationDeleteOpen}
				handleClose={async () => {
					setIsConfirmationDeleteOpen(false)
				}}
				title="Confirmação"
			>
				<div className="flex flex-col gap-6 mx-2">
					<p>Deseja realmente remover este lembrete?</p>

					<Button onClick={handleConfirmarExclusao} className="w-fit self-end">
						Confirmar
					</Button>
				</div>
			</Modal>

			<Modal
				isOpen={!!lembreteEmEdicao}
				title="Editar lembrete"
				handleClose={() => {
					setLembreteEmEdicao(null)
				}}
			>
				<FormCadastro 
					lembrete={lembreteEmEdicao} 
					onSubmit={() => { 
						setLembreteEmEdicao(null)

						refetchLembrete()
					}} 
				/>
			</Modal>
		</>
	)
}
